import React, { useState } from 'react';
import { Breadcrumb, Button, } from 'antd'; 
import {
  HomeIcon,
  DocumentChartBarIcon,
} from '@heroicons/react/16/solid';
import AddPayStructureForm from './addPayslipStructure';
import PaySlipStructureTable from './payslipStructureTable';
import { generatePayslipStructue } from './payslipStructureReport';

const PayslipStructurecomp = () => {
  const [isPayslipVisible, setPayslipVisible] = useState(false);
  const [salaryStructureData, setSalaryStructureData] = useState([]);
  const items = [
    {
      href: '/',
      title: (
        <span className="flex sm:gap-2 items-center">
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className="text-gray-400 sm:text-lg">Home</span>
        </span>
      ),
    },
    {
      href: '#',
      title: (
        <span className="flex sm:gap-2 items-center">
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className="text-gray-400 sm:text-lg">Salary Structure</span>
        </span>
      ),
    },
  ];
  const handlePayslipOk = async () => {
    setPayslipVisible(false);
  };
  return (
    <div>
      <div className="flex flex-wrap py-8 px-4 sm:p-10 justify-between items-center gap-4">
        <div className="flex flex-col gap-2 text-xl md:text-4xl font-black">
         Salary Structure
          <Breadcrumb items={items} />
        </div>
        <div className="flex space-x-2">
          <Button
            type="primary"
            className="bg-green-500 border-none hover:bg-green-600"
            onClick={() => setPayslipVisible(true)}
          >
            Add Salary Structure
          </Button>
          <Button
            type="primary"
            className="bg-blue-500 border-none hover:bg-blue-600"
            onClick={() => generatePayslipStructue(salaryStructureData)}
          >
            Download Salary Structure
          </Button>
        </div>
      </div>

     <PaySlipStructureTable  onDataReady={(data) => setSalaryStructureData(data)} />

      <AddPayStructureForm
        visible={isPayslipVisible}
        onCancel={() => setPayslipVisible(false)}
        onOk={handlePayslipOk}
      />
    </div>
  );
};

export default PayslipStructurecomp;